const printButtons = document.querySelectorAll('.accesibility-list .page-print')

if (printButtons) {
  printButtons.forEach(button => {
    button.addEventListener('click', () => {
      window.print()
    })
  })
}
